import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import axiosInstance from "../../utils/axiosInstance";
import { baseUrl, fetchDoctorProfile, imageBaseUrl } from "../../constants/ApiConstants";
import { Link, useNavigate } from "react-router-dom";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";
import FullPageLoader from "../../components/FullPageLoader";
import DoctorDetailHeader from "../../components/DoctorDetailHeader";
import { FaChevronRight } from "react-icons/fa6";
import { primaryColor } from "../../constants/colors";
import { updateDoctorData } from "../../store/appSlice";
export default function DoctorSetting() {
  pageTitle("Doctor Settings");

  const [loading, setLoading] = useState(false);
  const doctorId = useSelector((state) => state.appSlice.doctorData?.id);
  const [doctorDetail, setDoctorDetail] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorProfile, {
        doctor_id: doctorId,
      })
      .then((res) => {
        setDoctorDetail(res.data.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const routeList = [
    {
      name: "Edit Profile Details",
      path: "edit-doctor-profile",
    },
    {
      name: "Appointment History",
      path: "doctor-appointment-history",
    },
    {
      name: "Appointment Slots",
      path: "appointment-slots",
    },
    {
      name: "Manage Holidays",
      path: "manage-holidays",
    },
    { name: "Wallet", path: "wallet" },
    // { name: "Earning Report", path: "earning-report" },
    { name: "Payouts", path: "payouts" },
    { name: "Bank Details", path: "bank-details" },
    { name: "Terms of Use", path: "/termsOfUse", external: true },
    { name: "Privacy Policy", path: "/privacypolicy", external: true },
    // { name: "Help & FAQs", path: "" },
  ];

  return (
    <Wrapper>
      {loading ? (
        <FullPageLoader />
      ) : (
        <Section topMd={0} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
          <div className="content-wrapper d-flex flex-column px-3 gap-1 justify-content-center mx-auto">
            <CommonMobileHeader canBack title="Settings" />
            <div className="row">
              <div className="col-md-6">
                <DoctorDetailHeader image={`${doctorDetail?.image}`} name={doctorDetail?.name} designation={doctorDetail?.designation} degrees={doctorDetail?.degrees} />
              </div>
              <div className="col-md-6">
                <div className="w-full">
                  {routeList.map((route) => (
                    <Link key={route.name} className="d-flex justify-content-between align-items-center bg-grey2 mb-2 rounded" to={route?.external ? `${baseUrl}${route.path}` : route.path}>
                      <strong className="fs-normal text-dark fw-normal px-3 py-2  ">{route.name}</strong>
                      <FaChevronRight className="m-2" color={primaryColor} size={14} />
                    </Link>
                  ))}
                  <button
                    type="button"
                    className="d-flex justify-content-between align-items-center bg-grey2 mb-2 rounded w-100"
                    onClick={() => {
                      localStorage.removeItem("userData");
                      updateDoctorData(null);
                      navigate("/login-as-doctor", {
                        replace: true,
                      });
                    }}
                  >
                    <strong className="fs-normal fw-normal px-3 py-2 text-danger">{"Logout"}</strong>
                    <FaChevronRight className="m-2" color={"red"} size={14} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Section>
      )}
      {/* Edit Service Modal */}
    </Wrapper>
  );
}
const Wrapper = styled.div``;
